import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import ThongTinCongTy from './ThongTinCongTy';


const useStyles = makeStyles((theme) => ({
    boxTitle: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        fontSize: '1.5rem',
        color: '#000',
    },
    boldText: {
        fontWeight: 'bold',
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    // THÊM CLASS MỚI CHO HÌNH ẢNH RESPONSIVE Ở ĐÂY
    responsiveImage: {
        maxWidth: '100%', // Đảm bảo hình ảnh không vượt quá chiều rộng của phần tử cha
        height: 'auto',   // Tự động điều chỉnh chiều cao để duy trì tỷ lệ khung hình
        display: 'block', // Đảm bảo hình ảnh là block-level để áp dụng margin tự động
        margin: theme.spacing(2, 'auto'), // Căn giữa hình ảnh và thêm khoảng cách trên/dưới
    },
}));

const BaoHanhMoRong = () => {
    const classes = useStyles();


    return (
        <Box className={classes.root}>
            <Box className={classes.boxTitle}>
                <Typography variant="h5" className={classes.title}>
                    Bảo hành mở rộng
                </Typography>
            </Box>
            <Box>
                <Typography component="span" className={classes.boldText}> BẢO HÀNH MỞ RỘNG</Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Nhằm mục đích tăng cường sự gắn kết với khách hàng, chúng tôi đã tạo ra sản phẩm Bảo hành mở rộng, mong muốn đem lại sự an tâm và hài lòng cho khách hàng
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/1476847777455.jpg' className={classes.responsiveImage} alt="Thái Nguyên Ford" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    LỢI ÍCH BẢO HÀNH MỞ RỘNG
                </Typography>
                <br />
                <Box>
                    <ul>
                        <li>Chi phí hợp lý, quyền lợi bảo hành tối đa</li>
                        <li>Linh hoạt lựa chọn gói sản phẩm phù hợp</li>
                        <li>Không giới hạn số lần yêu cầu bảo hành</li>
                        <li>Không giới hạn số tiền yêu cầu bảo hành</li>
                        <li>Chuyển nhượng quyền bảo hành theo xe</li>
                        <li>Thời gian bảo hành sẽ được mở rộng ngay khi hết hạn bảo hành tiêu chuẩn</li>
                    </ul>
                </Box>
                <br />
                <Typography component="span" className={classes.boldText}>
                    GÓI TIẾT KIỆM
                </Typography>
                <br />
                <Typography variant="body1" >
                    Cung cấp dịch vụ mở rộng bảo hành cho trên 29 chi tiết phụ tùng / nhóm phụ tùng quan trọng liên quan đến sự vận hành của xe bao gồm động cơ, hộp số, hệ thống cầu chủ động.
                </Typography>
                <br />
                <Typography component="span" className={classes.boldText}>
                    GÓI AN TÂM
                </Typography>
                <br />
                <Typography variant="body1" >
                    Cung cấp dịch vụ mở rộng bảo hành cho trên 1000 chi tiết phụ tùng /nhóm phụ tùng tương tự như bảo hành tiêu chuẩn.
                </Typography>
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/6.jpg' className={classes.responsiveImage} alt="Khai trương đại lý" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    THỜI GIAN BẢO HÀNH
                </Typography>
                <br />
                <Typography variant="body1">
                    5 NĂM / 140.000 KM
                </Typography>
                <Typography variant="body1">
                    Khi mua bảo hành mở rộng , chiếc xe của bạn sẽ được cung cấp dịch vụ bảo hành mở rộng thêm với thời gian 1 năm/ 20.000 km hoặc 2 năm/ 40.000 km tùy theo điều kiện nào đến trước ngay sau khi hết thời gian bảo hành tiêu chuẩn và bạn sẽ yên tâm tận hưởng những giờ phút đầy sôi động bên người bạn bốn bánh của mình trên mọi nẻo đường.
                </Typography>
                <br />
                <Typography component="span" className={classes.boldText}>
                    SẢN PHẨM BẢO HÀNH MỞ RỘNG BAO GỒM
                </Typography>
                <Typography variant="body1">
                    Chi phí sửa chữa, thay thế các phụ tùng chính hãng bị khuyết tật được xác định do lỗi của nhà sản xuất
                </Typography>
                <Typography variant="body1">
                    Công lao động cho các hoạt động sửa chữa, thay thế nêu trên
                </Typography>
                <br />
                <Typography component="span" className={classes.boldText}>
                    SẢN PHẨM BẢO HÀNH MỞ RỘNG KHÔNG BAO GỒM
                </Typography>
                <Typography variant="body1">
                    Chi phí sửa chữa, thay thế các phụ tùng bảo dưỡng, các phụ tùng hao mòn
                </Typography>
                <Typography variant="body1">
                    Các chi phí khác được liệt kê trong “Các mục không bao gồm trong bảo hành” được quy định trong Sổ Bảo Hành & Chính sách bảo hành của Ford
                </Typography>
                <br />
                <br />
                <ThongTinCongTy />
            </Box>
        </Box>
    );
};

export default BaoHanhMoRong;